import Link from 'next/link'
import Image from 'next/image'
import { css, Theme } from '@emotion/react'
import { Typography, Divider } from '@mui/material'

type Props = {
  head: string
  description: string
  url: string[]
  image1: string
  image2: string
  description2: string
}

const WorksBody: React.FC<Props> = ({
  head,
  description,
  description2,
  url,
  image1,
  image2,
}) => {
  return (
    <section>
      <div css={styles.info}>
        <div css={styles.inner}>
          <Typography variant='h2' css={styles.head} color='primary'>
            {head}
          </Typography>
          <div css={styles.wrapper}>
            <div css={styles.descriptionContainer}>
              <Typography
                variant='body1'
                css={styles.description}
                color='primary'>
                {description}
              </Typography>
            </div>
            <div css={styles.infoWrapper}>
              <Divider />
              <table css={styles.table}>
                <tr>
                  <th css={styles.thead}>URL</th>
                  <td css={styles.tbody}>
                    {url.map(item => (
                      <Link href={item} passHref key={item}>
                        <a>{item}</a>
                      </Link>
                    ))}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div css={styles.content}>
        <div css={styles.image1}>
          <Image src={image1} layout='responsive' width={2400} height={1200} />
        </div>
        <div css={styles.descWrapper}>
          <Typography variant='body2' css={styles.description2} color='primary'>
            {description2}
          </Typography>
        </div>
        <div css={styles.image2}>
          <Image src={image2} layout='responsive' width={2400} height={1200} />
        </div>
      </div>
    </section>
  )
}

const styles = {
  info: css`
    max-width: 1180px;
    height: 100%;
    margin: 0 auto;
    @media (max-width: 960px) {
      position: relative;
      width: 100vw;
    }
  `,
  inner: css`
    padding: 100px 30px 100px;
    @media (max-width: 960px) {
      padding: 30px;
    }
  `,
  head: css`
    padding: 40px 0;
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.4rem;
    @media (min-width: 960px) {
      font-size: 2rem;
    }
  `,
  wrapper: css`
    display: flex;
    @media (max-width: 960px) {
      display: block;
    }
  `,
  descriptionContainer: css`
    width: 60%;
    padding: 20px 20px 20px 0;
    @media (max-width: 960px) {
      width: 100%;
      padding: 0;
    }
  `,
  description: css`
    padding: 20px 0;
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 500;
    font-size: 0.8rem;
    line-height: 2.4rem;
    @media (min-width: 960px) {
      font-size: 1rem;
    }
  `,
  infoWrapper: css`
    padding: 40px 0 0 20px;
    @media (max-width: 960px) {
      padding: 0;
    }
  `,
  table: css`
    padding: 20px 5px;
  `,
  thead: (theme: Theme) => css`
    color: ${theme.palette.primary.main};
    padding: 10px;
  `,
  tbody: (theme: Theme) => css`
    padding: 10px;
    margin-left: 20px;
    & a {
      color: ${theme.palette.primary.main};
    }
  `,
  content: css`
    display: flex;
    justify-content: center;
    flex-flow: column;
  `,
  image1: css`
    position: relative;
    @media (max-width: 960px) {
    }
  `,
  descWrapper: css`
    position: relative;
    max-width: 1000px;
    margin: 0 auto;
  `,
  description2: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 500;
    font-size: 0.9rem;
    line-height: 3rem;
    padding: 140px 40px;
    @media (min-width: 960px) {
      font-size: 1.1rem;
    }
  `,
  image2: css`
    position: relative;
    @media (max-width: 960px) {
    }
  `,
}

export default WorksBody
